/**
 * Allowed parent page titles for chapter pages.
 * These pages show up as tiles on the chapter home page.
 *
 * The reason we check titles instead of slugs is because
 * we want to prevent the user from changing the title to keep
 * the chapter pages consistent.
 */
export const allowedParentPageTitles = [
    'About Us',
    'Stay in Touch',
    'Local Badger Hangouts',
    'Get Involved',
    'Student Scholarships',
    'Chapter News',
    'Local Alumni Recognition',
    'Past Events',
    'Upcoming Events',
]

export function allowedParentPage(page) {
    return allowedParentPageTitles.includes(page?.title)
}

export function sortChapterPage(a, b) {
    if (a.menuOrder < b.menuOrder && a.menuOrder) {
        return -1
    }
    if (a.menuOrder > b.menuOrder || !a.menuOrder) {
        return 1
    }
    return 0
}
